import { createContext, useContext } from "react";
import { useFormAdmin } from "../hooks";
const Context = createContext();

export const FormAdminProvider = ({ children }) => {
  return <Context.Provider value={useFormAdmin()}>{children}</Context.Provider>;
};

export const useFormAdminContext = () => useContext(Context);
